import axios from 'axios'

export default {

    getVideos(params = {}) {
        return axios.get('/ugc/admin', { params })
    },
    getEventVideos(params){
        return axios.get(`/ugc/admin/${params.eventId}`)
    },
    postGiftVideo(payload) {
        return axios.post(`/ugc/admin/gift`, payload)
    },
    deleteGiftVideo(payload) {
        return axios.delete('/ugc/admin/gift', { data: payload })
    },
    updateUgcVideo(payload) {
        return axios.patch('/ugc/admin', payload)
    }
}
